import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import api from "../services/api";
import "../styles/Login.css";
import leftImg from "../assets/left.png";
import logoImg from "../assets/helios-logo.jpg";

const RECAPTCHA_SITE_KEY = "6LcdCxcsAAAAAF_c8lQRaOtnhuLWPTJ6l_h2k6HL";

const Login = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const { login, switchBranch } = useContext(AuthContext);
  const navigate = useNavigate();
  const recaptchaContainerRef = useRef(null);
  const recaptchaWidgetId = useRef(null);

  useEffect(() => {
    const renderWidget = () => {
      if (window.grecaptcha && recaptchaContainerRef.current && recaptchaWidgetId.current === null) {
        recaptchaWidgetId.current = window.grecaptcha.render(recaptchaContainerRef.current, {
          sitekey: RECAPTCHA_SITE_KEY
        });
      }
    };

    if (window.grecaptcha && window.grecaptcha.render) {
      renderWidget();
    } else {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        // grecaptcha loads asynchronously; poll briefly until ready
        const check = setInterval(() => {
          if (window.grecaptcha && window.grecaptcha.render) {
            clearInterval(check);
            renderWidget();
          }
        }, 100);
      };
      document.body.appendChild(script);
    }
  }, []);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const recaptchaToken = window.grecaptcha && recaptchaWidgetId.current !== null
      ? window.grecaptcha.getResponse(recaptchaWidgetId.current)
      : "";

    if (!recaptchaToken) {
      setError("Please complete the reCAPTCHA verification.");
      return;
    }

    try {
      const response = await api.post("/auth/login", { ...credentials, recaptchaToken });
      const { token, user, branch } = response.data;

      // Store user info
      localStorage.setItem("token", token);
      localStorage.setItem("username", user.name);
      localStorage.setItem("user_id", user.id);
      localStorage.setItem("user", JSON.stringify(user));

      // Store active branch
      // Fixed users (admin/staff) → their assigned branch
      // Senior roles (null branch) → branch will be set from switcher; default to null for now
      if (branch) {
        localStorage.setItem("activeBranch", JSON.stringify(branch));
        switchBranch(branch);
      }

      login(token);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      setError(error.response?.data?.error || "Invalid email or password.");
      if (window.grecaptcha && recaptchaWidgetId.current !== null) {
        window.grecaptcha.reset(recaptchaWidgetId.current);
      }
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-left">
          <img src={leftImg} alt="Side" />
        </div>
        <div className="login-right">
          <img src={logoImg} alt="Logo" style={{ height: "80px", marginBottom: "20px" }} />

          <div className="login-box">
            <h2>Inventory Management System</h2>
            {error && <p className="error-message">{error}</p>}
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={credentials.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group" style={{ display: "block" }}>
                <div ref={recaptchaContainerRef}></div>
              </div>
              <button type="submit" className="login-button">Login</button>
            </form>
            <p>
              <Link to="/forgot-password" className="forgot-link">Forgot Password?</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
